import src from "IMAGE";
export default { src, width: 570, height: 205, blurWidth: 8, blurHeight: 3, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAADCAYAAACuyE5IAAAARElEQVR42i2MyQ0AMQgD84T0XwniprnFqzyQBjP4ZCa7O4sIqSphnxnubq4qOhEB+AfiSoxsmSCeF5KZEXgb7h4uHiB8NuQ0aEvwoFkAAAAASUVORK5CYII="};
